module.exports = __webpack_public_path__ + "static/media/event-logo-1012-neoventure.9b30d358.png";